import { defineFcm } from '../shared/factory';

export const FCM_BETA_LOCALES_ENABLED = defineFcm('beta_locales_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Locales used on the site',
		description: `Enable beta locales on the site. This will not impact the locale selector in the footer but will allow setting the locale using ?lang=<locale_code>.

		Only global group is supported.`,
		import: false,
	});
